// extracted by mini-css-extract-plugin
module.exports = {"customLabelButton":"customLabelButton_customLabelButton__2qBqw"};